import clientAxios from "../../client";

import { formatQueryString } from "@/common/utils/common";
import type { QueryType } from "@/common/types/common";

import type { PlanPayloadType } from "@/common/types/plan/plan";

export async function planPriceList(plan_id: string, query?: QueryType) {
	const queryString = formatQueryString(query);

	return await clientAxios.get(`plan/${plan_id}/price/list${queryString}`);
}

export async function planPriceGet(item_id: string) {
	return await clientAxios.get(`plan/price/${item_id}/show`);
}

export async function planPriceCreate(payload: any) {
	return await clientAxios.post(`plan/price/create`, payload);
}

export async function planPriceUpdate(item_id: string, payload: any) {
	return await clientAxios.put(`plan/price/${item_id}/update`, payload);
}

export async function planPricePatch(item_id: string, payload: Partial<any>) {
	return await clientAxios.patch(`plan/price/${item_id}/patch`, { payload });
}

export async function planPriceDelete(item_id: string) {
	return await clientAxios.del(`plan/price/${item_id}/delete`);
}
